import React from "react";
import {
    Button,
    convertInputFormToObject,
    DateTimePickerField,
    InputForm, inputStyles,
    SelectField,
    TextField,
    useInputForm
} from "../../../Components/Inputs";
import {clearInputFormFields} from "../../../Components/Inputs/inputUtility";
import {GridCell, gridConstants, GridContainer} from "../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../Components/Inputs/SearchableSingleSelectField";
import {createListFromArray, createListFromArrayOfObjects} from "../../../Utilities/Types/listUtilities";
import {
    EDUCATIONAL_FACILITY_LIST,
    GRADE_LEVEL_LIST,
    STUDENT_APPROVAL_STATUS_LIST_FOR_FIMC_ADMIN_SEARCH,
    STUDENT_APPROVAL_STATUS_LIST_FOR_SEARCH,
    STUDENT_INACTIVE_REASON_LIST,
    STUDENT_STATUS_LIST
} from "../studentConstants";
import {Allow, policyEvents} from "../../../Components/Authorize";
import {isFimcAdmin} from "../../../Utilities/LocalStorage/storageUtilities";

interface StudentApprovalSearchFormViewProps {
    buttonSharedSettings: Record<string, unknown>;
    districts: Record<string, any>[];
    handleSetStudentSearchCriteria: (criteria: Record<string, unknown>) => void;
    isLoading: boolean;
    organizations: string[];
    studentSearchCriteria: Record<string, any>;
}

export const StudentApprovalSearchFormView: React.FC<StudentApprovalSearchFormViewProps> = ({
                                           buttonSharedSettings,
                                           districts,
                                           handleSetStudentSearchCriteria,
                                           isLoading,
                                           organizations,
                                           studentSearchCriteria
}) => {

    const organizationOptions = createListFromArray(organizations);

    const searchForm = useInputForm(studentSearchCriteria);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedStudentSearchCriteria = {...studentSearchCriteria};
        updatedStudentSearchCriteria.ClearStudentSearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedStudentSearchCriteria = {...studentSearchCriteria};
        updatedStudentSearchCriteria.Search(criteria);
        handleSetStudentSearchCriteria(updatedStudentSearchCriteria);
    };

    const inputSharedSettings = {
        large_columns: gridConstants.column.THREE,
        medium_columns: gridConstants.column.SIX,
    };

    return <>
        <InputForm name={"userSearch"}>

            <TextField
                {...searchForm.studentName}
                {...inputSharedSettings}
                label={`Name`}
            />
              <TextField
                {...searchForm.fimcStudentId}
                {...inputSharedSettings}
                label={`Student Id`}
            />


            <DateTimePickerField
                {...searchForm.dateOfBirth}
                {...inputSharedSettings}
            />

            <Allow policyEvent={policyEvents.ADVANCE_SEARCH}>
                <SearchableSingleSelectField
                    {...searchForm.districtId}
                    {...inputSharedSettings}
                    defaultOption={"All"}
                    includeDefaultOption
                    label={'District'}
                    options={createListFromArrayOfObjects(districts, "id", "districtName")}
                />
            </Allow>

            <SelectField
                {...searchForm.gradeLevel}
                {...inputSharedSettings}
                defaultOptionValue={""}
                defaultOption={"All"}
                includeDefaultOption
                options={GRADE_LEVEL_LIST}
            />

            <TextField
                {...searchForm.patronName}
                {...inputSharedSettings}
            />

            <SelectField
                {...searchForm.educationalFacility}
                {...inputSharedSettings}
                defaultOptionValue={""}
                defaultOption={"All"}
                includeDefaultOption
                label={`Educational Facility Type`}
                options={EDUCATIONAL_FACILITY_LIST}
            />

            <SelectField
                {...searchForm.studentApprovalStatus}
                {...inputSharedSettings}
                defaultOptionValue={""}
                defaultOption={"All"}
                includeDefaultOption
                options={isFimcAdmin()? STUDENT_APPROVAL_STATUS_LIST_FOR_FIMC_ADMIN_SEARCH :STUDENT_APPROVAL_STATUS_LIST_FOR_SEARCH}
            />

            <SelectField
                {...searchForm.studentStatus}
                {...inputSharedSettings}
                includeDefaultOption
                options={STUDENT_STATUS_LIST}
            />

            <SelectField
                {...searchForm.studentInactiveReason}
                {...inputSharedSettings}
                includeDefaultOption
                options={STUDENT_INACTIVE_REASON_LIST}
            />

            {
                organizations.length > 0 &&
                <SelectField
                    {...searchForm.organization}
                    {...inputSharedSettings}
                    defaultOptionValue={""}
                    defaultOption={"All"}
                    includeDefaultOption
                    options={organizationOptions}
                />
            }

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>

                    <GridCell {...buttonSharedSettings}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            isPrimary
                            label="Search"
                            name="btnSearchStudents"
                            onClick={handleSearchClick}
                        />
                    </GridCell>

                    <GridCell {...buttonSharedSettings} medium_offset={gridConstants.column.SIX}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            label="Clear"
                            name="btnClearStudentSearch"
                            onClick={handleClearClick}
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>;
};
